import React from 'react';
import { Wrapper } from '../components';
import { Accordion, Alert, Badge, Breadcrumbs, Button, Carousel, Jumbotron, Progress, Tabs, Modal, Toast } from '../components/Bootstrap';

class ComponentsView extends React.Component{
    
    constructor(props) {
        super(props);
        this.showModal = this.showModal.bind(this);
        this.myModal = React.createRef();
        this.state = {
            breadcrumbItems: [{label:"Home",link:"../../"},{label:"React",link:"./"},{label:"Elements",link:"./elements"}]
        };
    }
    
    showModal() {
        this.myModal.current.show();
    }

    render(){
        const { breadcrumbItems } = this.state;
        return (
            <Wrapper>
                <div className="row mb-2 align-items-center">
                    <div className="col-lg-12 pb-3">
                        <Breadcrumbs className="border rounded" items={breadcrumbItems} activeIndex={2} />
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Jumbotron</h3>
                        <div className="w-75 mx-auto">
                            <Jumbotron className="border border-light shadow shadow-lg" action={<Button />} />
                        </div>
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Accordion</h3>
                        <Accordion className="border rounded shadow-sm" />
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Alerts</h3>
                        <div>
                            <Alert context="danger" message="Hey wow there's a message here!" />
                        </div>
                        <div>
                            <Alert context="primary" message="This is a primary alert message." />
                        </div>
                        <div>
                            <Alert context="success" message="This is a success alert message." />
                        </div>
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Badges</h3>
                        <div>
                            <Badge /> <Badge context="danger" content="danger" /> <Badge context="primary" content="primary" /> <Badge context="warning" content="warning" />  <Badge pill={true} content="pill" /> 
                        </div>
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Progress Bars</h3>
                        <div className="py-1">
                            <Progress width={.80} />  
                        </div>
                        <div className="py-1">
                            <Progress width={.20} context="danger" />  
                        </div>
                        <div className="py-1">
                            <Progress width={.40} context="warning" />  
                        </div>
                        <div className="py-1">
                            <Progress width={.97} context="info" striped={false} />  
                        </div>
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Modal</h3>
                        <button type="button" className="btn btn-primary btn-lg" onClick={() => this.showModal()}>Show Modal</button>
                        <Modal ref={this.myModal} content="You can pass content to the modal via HTML attributes that are used as React props." />
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Tabs</h3>
                        <Tabs />
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Toast</h3>
                        <div>
                            <Toast context="danger" message="Hey wow there's a message here!" label="7 mins ago" />
                        </div>
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Buttons</h3>
                        <div className="p-2">
                            <h6 className="text-muted">Standard</h6>
                            <Button className="mr-2" content="Info" /> 
                            <Button className="mr-2" context="danger" content="Danger" /> 
                            <Button className="mr-2" context="primary" content="Primary" /> 
                            <Button className="mr-2" context="warning" content="Warning" />  
                            <Button className="mr-2" context="dark" content="Dark" /> 
                        </div>
                        <div className="p-2">
                            <h6 className="text-muted">Large Outline</h6>
                            <Button className="mr-2" content="Info" outline={true} large={true} /> 
                            <Button className="mr-2" context="danger" content="Danger" outline={true} large={true} /> 
                            <Button className="mr-2" context="primary" content="Primary" outline={true} large={true} /> 
                            <Button className="mr-2" context="warning" content="Warning" outline={true} large={true} />  
                            <Button className="mr-2" context="success" content="Success" outline={true} large={true} /> 
                        </div>
                        <div className="p-2">
                            <h6 className="text-muted">Button with Badge</h6>
                            <Button className="mr-2" context="primary" large={true}>
                                Notifications <Badge context="dark" pill={true} content="1" />
                            </Button> 
                        </div>
                        <div className="p-2">
                            <h6 className="text-muted">Rounded</h6>
                            <Button className="mr-2 rounded-pill" content="Info" /> 
                            <Button className="mr-2 rounded-pill" context="danger" content="Danger" /> 
                            <Button className="mr-2 rounded-pill" context="primary" content="Primary" /> 
                            <Button className="mr-2 rounded-pill" context="warning" content="Warning" />  
                            <Button className="mr-2 rounded-pill" context="success" content="Success" /> 
                        </div>
                        <div className="p-2">
                            <h6 className="text-muted">Button Toolbar</h6>
                            <div className="btn-group" role="group" aria-label="Buttons Group">
                                <button type="button" className="btn btn-secondary mb-2">Start</button>
                                <button type="button" className="btn btn-secondary mb-2">1</button>
                                <button type="button" className="btn btn-secondary mb-2">2</button>
                                <button type="button" className="btn btn-secondary mb-2">3</button>
                                <button type="button" className="btn btn-secondary mb-2">End</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 py-4">
                        <h3 className="font-weight-light">Carousel</h3>
                        <div className="w-75 mx-auto">
                            <Carousel />
                        </div>
                    </div>
                </div>
            </Wrapper>
        );
    }
}

export default ComponentsView;
